import React from 'react';
import {NavLink} from 'react-router-dom';
import {FiHome,FiGrid,FiLayers,FiMessageCircle,FiCalendar} from 'react-icons/fi';

const items = [
  {label:'Home',to:'/',icon:FiHome,end:true},
  {label:'Products',to:'/products',icon:FiGrid},
  {label:'Services',to:'/services',icon:FiLayers},
  {label:'Contact',to:'/contact',icon:FiMessageCircle},
  {label:'Book a call',to:'/consultation',icon:FiCalendar,featured:true}
];

export default function MobileNavigation(){
  return <nav className="mobile-bottom-nav" aria-label="Quick navigation">
    {items.map(({label,to,icon:Icon,end,featured})=><NavLink key={to} to={to} end={end} className={({isActive})=>`mobile-bottom-link${isActive?' active':''}${featured?' featured':''}`}>
      <Icon aria-hidden="true" size={21}/><span>{label}</span>
    </NavLink>)}
  </nav>;
}
